import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthenticationService } from './authentication.service';

export const authGuard: CanActivateFn = async () => {
    const authService = inject(AuthenticationService);

    const isValid = await authService.isSessionValid();

    if (isValid) {
        return true;
    }

    return false;
};
